import { Routes } from '@angular/router';
import { MailViewComponent } from './components/mail-view/mail-view.component';

export const routes: Routes = [
  { path: '', component: MailViewComponent },
  { path: '**', redirectTo: '' },
];
